import { useContext } from 'react'

import { MarketBasketContext } from '@views/MarketBaskets/MarketBaskets.hooks'
import { UseFormReturn, useWatch } from 'react-hook-form'

/**
 * Choose the correct color when a setting has a value or not
 */
export const chooseColor = (value: boolean) => {
	if (value) return 'text.primary'
	return 'text.secondary'
}

/**
 * Get the basket's currency code from the basket when editing, or the parent
 * creation form when new (context may not exist during creation).
 */
export const useBasketCurrency = (parentForm?: UseFormReturn<any> | null) => {
	// Basket context may not exist, so doing it this way gets around the useMarketBasket error
	const currencyBasket = useContext(MarketBasketContext)?.marketBasket?.currency
	const currencyWatch = useWatch({ control: parentForm?.control, name: 'currency' })

	return currencyWatch?.id || currencyBasket || 'USD'
}

export const settingsDefaults = {
	groupBy: 'CUSTOMER_LOCATION',
	switchDirectDeals: true,
	highVolumeMfr: {
		enabled: false,
		cases: 2000,
		spend: 50000,
	},
	highestRebate: { enabled: false, value: 4 },
	restrictedManufacturer: true,
	sameManufacturer: false,
	programs: {
		direct: true,
		beBrandExtendable: true,
		bePlatform: true,
		entegra: true,
	},
	purchaseQuantity: { enabled: false, value: 100 },
	savingsMoreThan: { type: 'PERCENT', value: 40 },
	packSize: { low: 0.25, high: 2.5 },
	caseQty: { enabled: true, value: 100 },
	preferExactMatch: true,
	estimatedFob: { enabled: false, value: 15 },
	annualizationMonths: 12,
}
